import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import RHFRadioGroup from "@/common/HOCs/rhf/radio-group/RHFRadioGroup";
import useDirection from "@hooks/useDirection";
import RHFInputCurrency from "@/common/HOCs/rhf/input/RHFInputCurrency";
import { toast } from "sonner";
import { useForm } from "react-hook-form";
import { useDynamicForm } from "@/pages/finance-eligibility/context/ScreenContext";
import { useTranslation } from "@i18n";
import useBoolean from "@hooks/useBoolean";
import { useEffect, useRef } from "react";
var CardOptions = function CardOptions(_ref) {
  var screenData = _ref.screenData;
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderOptions(screenData));
};
var SELECTION_ANIMATION_DURATION = 1000;
var renderOptions = function renderOptions(screenData) {
  if (!(screenData !== null && screenData !== void 0 && screenData.options)) return null;
  var direction = useDirection();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useForm = useForm(),
    trigger = _useForm.trigger;
  var _useDynamicForm = useDynamicForm(),
    goToStep = _useDynamicForm.goToStep,
    currentStep = _useDynamicForm.currentStep,
    setState = _useDynamicForm.setState,
    state = _useDynamicForm.state;
  var blink = useBoolean(false);
  var animationTimeOutRef = useRef(null);
  var handleChangeOption = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(value) {
      var isValid, _screenData$options$f, _screenData$options$f2, next_id, disqualify;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (currentStep !== null && currentStep !== void 0 && currentStep.next_text) {
              _context.n = 4;
              break;
            }
            _context.n = 1;
            return trigger();
          case 1:
            isValid = _context.v;
            if (!isValid) {
              _context.n = 3;
              break;
            }
            next_id = screenData === null || screenData === void 0 ? void 0 : (_screenData$options$f = screenData.options.find(function (option) {
              return option.value === value;
            })) === null || _screenData$options$f === void 0 ? void 0 : _screenData$options$f.next_id;
            disqualify = screenData === null || screenData === void 0 ? void 0 : (_screenData$options$f2 = screenData.options.find(function (option) {
              return option.value === value;
            })) === null || _screenData$options$f2 === void 0 ? void 0 : _screenData$options$f2.disqualify;
            if (disqualify) {
              setState(_objectSpread(_objectSpread({}, state), {}, {
                disqualify: true
              }));
            } else {
              setState(_objectSpread(_objectSpread({}, state), {}, {
                disqualify: false
              }));
            }
            _context.n = 2;
            return triggerAnimation().then(function () {
              goToStep(next_id);
            });
          case 2:
            _context.n = 4;
            break;
          case 3:
            toast.warning(t("verify_accuracy_information", {
              ns: "web_common"
            }), {
              position: "top-center",
              duration: 5000
            });
          case 4:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleChangeOption(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var triggerAnimation = function triggerAnimation() {
    return new Promise(function (resolve) {
      if (!blink.value) {
        blink.setTrue();
        animationTimeOutRef.current = setTimeout(function () {
          blink.setFalse();
          animationTimeOutRef.current = null;
          resolve(true);
        }, SELECTION_ANIMATION_DURATION);
      } else {
        resolve(true);
      }
    });
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };
  useEffect(function () {
    return function () {
      if (animationTimeOutRef.current) {
        clearTimeout(animationTimeOutRef.current);
      }
    };
  }, []);
  if (screenData.type === "radio") {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-3"
    }, /*#__PURE__*/React.createElement(RHFRadioGroup, {
      name: screenData === null || screenData === void 0 ? void 0 : screenData.field_name,
      options: screenData === null || screenData === void 0 ? void 0 : screenData.options,
      key: screenData === null || screenData === void 0 ? void 0 : screenData.field_name,
      defaultValue: null,
      direction: direction,
      onChange: handleChangeOption,
      className: blink.value ? "aria-selected:animate-blink aria-selected:border aria-selected:border-solid aria-selected:border-primary" : ""
    })));
  } else if ((screenData === null || screenData === void 0 ? void 0 : screenData.type) === "currency") {
    var _screenData$options;
    return /*#__PURE__*/React.createElement(React.Fragment, null, screenData === null || screenData === void 0 ? void 0 : (_screenData$options = screenData.options) === null || _screenData$options === void 0 ? void 0 : _screenData$options.map(function (option, index) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col gap-1"
      }, /*#__PURE__*/React.createElement(RHFInputCurrency, {
        key: 'currency-' + index,
        name: screenData === null || screenData === void 0 ? void 0 : screenData.field_name,
        label: option === null || option === void 0 ? void 0 : option.label,
        currencyLabel: t("sar", {
          ns: "web_common"
        }),
        autoFocus: true,
        inputContainerClassName: "h-full",
        onKeyDown: handleKeyDown,
        labelClassName: "en:left-0",
        disallowZero: true
      })));
    }));
  }
};
export default CardOptions;